module.exports = __webpack_public_path__ + "static/media/tech.e258cfb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Tech/assets/tech.jpg
// module id = 375
// module chunks = 0